import React from "react";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="primary-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-7 pe-lg-8">
              <a className="navbar-brand logo footer-logo" href="index.html">
                <img
                  className="img-fluid"
                  src="./assets/images/logo.png"
                  alt=""
                />
              </a>
              <p className="mt-4 mb-5">
                Qatar’s trusted partner for driving online success. We
                specialize in Search Engine Optimization (SEO), Geo Targeting
                (GEO), Answer Engine Optimization (AEO), and innovative digital
                marketing strategies that help your business reach the right
                audience, at the right time, on the right platform.
              </p>
            </div>
            <div className="col-lg-4 col-md-5 mt-6 mt-md-0">
              <h5>Contact Seoland</h5>
              <ul className="media-icon list-unstyled">
                <li>
                  <i className="flaticon-gps-1"></i>
                  <h6>Visit Our Location</h6>
                  <p className="mb-0">
                    #10, 2nd Floor, Bldg no: 210
                    <br />
                    Nuaija, Al Hilal, Doha - Qatar.{" "}
                  </p>
                </li>
                <li>
                  <i className="flaticon-email"></i>
                  <h6>Send Us Email</h6>
                  <a href="mailto:info@foxmedia.qa">info@foxmedia.qa</a>
                </li>
                <li>
                  <i className="flaticon-mobile"></i>
                  <h6>Looking For Project</h6>
                  <a href="tel:+97470598308">+974 - 7059 8308</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-8 mt-6 mt-lg-0">
              <div className="row">
                <div className="col-md-6 footer-menu">
                  <h5>Our Services</h5>

                  <ul className="list-unstyled w-100">
                    <li>
                      <a href="">Web Design</a>
                    </li>
                    <li>
                      <a href="">Web Development</a>
                    </li>
                    <li>
                      <a href="">Mobile App Development</a>
                    </li>
                    <li>
                      <a href="">Software Development</a>
                    </li>
                    <li>
                      <a href="">Information Technology</a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-6 mt-5 mt-md-0 footer-menu">
                  <h5>Our Products</h5>
                  <ul className="list-unstyled">
                    <li>
                      <a href="">Q – POSS Software</a>
                    </li>
                    <li>
                      <a href="">WhatsApp Marketing</a>
                    </li>
                    <li>
                      <a href="">Cheque Printing Software</a>
                    </li>
                    <li>
                      <a href="">Inventory Management</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="secondary-footer">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center">
              <div className="col-md-6">
                Copyright 2025 Fox Media Theme by{" "}
                <u>
                  <a href="#">Astra</a>
                </u>{" "}
                | All Rights Reserved{" "}
              </div>
              <div className="col-md-6 text-md-end mt-3 mt-md-0">
                <ul className="list-inline ps-0 ms-0 footer-social">
                  <li className="list-inline-item">
                    <a href="#">
                      <i className="flaticon-facebook-app-symbol"></i>
                    </a>
                  </li>

                  <li className="list-inline-item">
                    <a href="#">
                      <i className="flaticon-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="#">
                      <i className="flaticon-twitter-2"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="#">
                      <i className="flaticon-linkedin-1"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dark-bg ht-bg-move"></div>
    </footer>
  );
};
